/**
 * 길드 그림 주소. 서버가 **그 길드 마스터의 프로필 사진**을 내준다 — 마스터 얼굴이 없으면 예전 엠블럼
 * (사용자 2026-10-15: "길드 프로필이 길드마스터의 프로필이 보이도록 전부 다", backend utils/guildMaster.ts).
 *
 * 끝의 `?p=m` 은 서버가 보지 않는 표시다. 같은 주소로 7일 캐시된 옛 엠블럼이 브라우저에 남아 있어서,
 * 주소를 바꿔 새로 받게 한다.
 */
export const guildImg = (name?: string | null) => `/images/guild/${name}.png?p=m`;
